import { RadioField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { useTooltip } from '@calendly/ui/components/tooltip';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PHONE_CALL_KINDS } from '../../constants';
import { Base } from '../base';
import { InboundCallDetails } from './inbound_call_details';
import { RadioLabel } from './radio_label';
const tooltipContainerCss = "t1nomwp5";
const TooltipContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tooltipContainerCss, props.className)} />;
});

// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.location.inlines.outbound_call.header')
// i18n-tasks-use t('publisher.event_type_editor.sections.event_details.location.inlines.inbound_call.header')

export const PhoneCallInline = ({
  kind,
  fieldNamePrefix,
  tooltipText,
  possibleKinds,
  onKeyPress = () => {}
}) => {
  const isOutboundCallDisabled = !possibleKinds.includes(PHONE_CALL_KINDS.outbound);
  const [Tooltip, tooltipHostProps] = useTooltip(tooltipText);
  const tooltipContainerProps = isOutboundCallDisabled ? tooltipHostProps : {};
  const fieldName = `${fieldNamePrefix}.kind`;
  return <Base header={I18n.t(`publisher.event_type_editor.sections.event_details.location.inlines.${kind}.header`)}>
      <TooltipContainer {...tooltipContainerProps}>
        <RadioField bulletPosition="top" label={<RadioLabel kind={PHONE_CALL_KINDS.outbound} isDisabled={isOutboundCallDisabled} />} name={fieldName} value={PHONE_CALL_KINDS.outbound} disabled={isOutboundCallDisabled} />
        <Tooltip />
      </TooltipContainer>
      <RadioField bulletPosition="top" label={<RadioLabel kind={PHONE_CALL_KINDS.inbound} />} name={fieldName} value={PHONE_CALL_KINDS.inbound} />
      <InboundCallDetails kind={kind} fieldNamePrefix={fieldNamePrefix} onKeyPress={onKeyPress} />
    </Base>;
};

require("./phone_call_inline.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./phone_call_inline.js");